export const BASE_URL = process.env.REACT_APP_LOCAL_URL;
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;